import ContentLoader from "react-content-loader";
import React from "react";

const ListLoader = () => {
  const desktopVersion = (
    <ContentLoader
      height={60}
      primaryColor="#f3f3f3"
      secondaryColor="#ecebeb"
      speed={2}
      width={900}
    >
      <circle cx="42" cy="30" r="20" />
      <rect height="10" rx="3" ry="3" width="100" x="105" y="23"></rect>
      <rect height="10" rx="3" ry="3" width="100" x="280" y="23"></rect>
      <rect height="10" rx="3" ry="3" width="100" x="530" y="23"></rect>
      <rect height="10" rx="3" ry="3" width="100" x="710" y="23"></rect>
    </ContentLoader>
  );

  const mobileStyles = {
    "background-color": "#ffffff",
    "border-radius": "4px",
    "box-shadow": "0 4px 14px 0 rgba(0, 0, 0, 0.09)",
    padding: "16px 20px",
    width: "100 %",
  };

  const mobileVersion = (
    <ContentLoader
      height={300}
      primaryColor="#f3f3f3"
      secondaryColor="#ecebeb"
      speed={2}
      width={900}
    >
      <circle cx="60" cy="60" r="50"></circle>
      <rect height="20" rx="3" ry="3" width="400" x="200" y="30"></rect>
      <rect height="20" rx="3" ry="3" width="250" x="200" y="80"></rect>
      <rect height="5" rx="3" ry="3" width="900" x="0" y="180"></rect>
      <rect height="20" rx="3" ry="3" width="200" x="150" y="250"></rect>
      <rect height="20" rx="3" ry="3" width="200" x="550" y="250"></rect>
    </ContentLoader>
  );

  return (
    <>
      <div className="d-none d-lg-block">{desktopVersion}</div>
      <div className="d-none d-lg-block">{desktopVersion}</div>
      <div className="d-none d-lg-block">{desktopVersion}</div>
      <div className="d-lg-none mb-3" style={mobileStyles}>
        {mobileVersion}
      </div>
      <div className="d-lg-none mb-3" style={mobileStyles}>
        {mobileVersion}
      </div>
      <div className="d-lg-none" style={mobileStyles}>
        {mobileVersion}
      </div>
    </>
  );
};

export default ListLoader;
